import { render, staticRenderFns } from "./LogsTabela.vue?vue&type=template&id=1ae9e780&scoped=true&"
import script from "./LogsTabela.vue?vue&type=script&lang=js&"
export * from "./LogsTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9e780",
  null
  
)

export default component.exports